export const environment = {
  cliendId: 'Apr12vTBjjigbfPS1Vs9WvTv972MIiL2',
  production: false,
  baseUrl: 'https://generic-gateway-us-central1-esa24sg.uc.gateway.dev',
  authApiUrl: '/api/gateway/v1/auth',
  auth0_domain: "rentokil-initial-internal-staging.eu.auth0.com",
  region: "US",
  locale: 'en-US'

};


// Get clientId from GCP project OAuth2 credential path
// base url should be generic api gateway endpoint
// authApiUrl should be the auth rest end point from generic api gateway
